import { render, staticRenderFns } from "./view-in-year-budget-request.vue?vue&type=template&id=8810b2d8"
import script from "./view-in-year-budget-request.ts?vue&type=script&lang=ts&external"
export * from "./view-in-year-budget-request.ts?vue&type=script&lang=ts&external"
import style0 from "./view-in-year-budget-request.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8810b2d8')) {
      api.createRecord('8810b2d8', component.options)
    } else {
      api.reload('8810b2d8', component.options)
    }
    module.hot.accept("./view-in-year-budget-request.vue?vue&type=template&id=8810b2d8", function () {
      api.rerender('8810b2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/view-in-year-budget-request.vue"
export default component.exports